// Import polyfills:
import 'core-js/features/object/assign';
import 'core-js/features/object/keys';
import 'core-js/features/array/for-each';

import 'nuun_scripts';
import 'select2';
import $ from 'jquery';

// Init select 2:
$(() => {
    $('select').select2();
});

/**
 * Takes a string and, if needed, prepends the prefix (https://), if needed.
 * It checks if the given string do not already has a protocol beginning.
 *
 * @param {String} value String to make an URL from
 * @returns complete URL
 */
window.makeCompleteUrl = function (value, prefix = 'https://') {
    if (value && value.length > 0) {
        if (!value.toLowerCase().match(/^[a-zA-Z]+:\/\//)) {
            return prefix + value;
        }
    }
    return value;
};
